import React from "react";

import AccessStatus from "@mapmycustomers/shared/types/entity/common/AccessStatus";
import { RawFile } from "@mapmycustomers/shared/types/File";

import FileRow from "@app/component/FileRow";

import styles from "./NonViewableFileItems.module.scss";

interface NonViewableFileItemsProps {
  accessStatus?: AccessStatus;
  canDelete?: boolean;
  deleteTooltip?: string;
  editingTags?: boolean;
  nonViewableFiles: RawFile[];
  onChange?: (file: RawFile) => void;
  onDelete?: (file: RawFile) => void;
  onDownload: (file: RawFile) => void;
  size: "default" | "small";
  supportsTags?: boolean;
}

const NonViewableFileItems = ({
  accessStatus,
  canDelete = true,
  deleteTooltip,
  editingTags,
  nonViewableFiles,
  onChange,
  onDelete,
  onDownload,
  size,
  supportsTags,
}: NonViewableFileItemsProps) => {
  return (
    <div className={styles.container}>
      {nonViewableFiles.map((file) => (
        <FileRow
          accessStatus={accessStatus}
          canDelete={canDelete}
          deleteTooltip={deleteTooltip}
          editingTags={editingTags}
          file={file}
          key={file.id}
          onChange={onChange}
          onClick={onDownload}
          onDelete={onDelete}
          onDownload={onDownload}
          size={size}
          supportsTags={supportsTags}
        />
      ))}
    </div>
  );
};

export default NonViewableFileItems;
